import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { IWhatsAppMessageParams, WhatsAppState } from './types';

export const useWhatsAppStore = create<WhatsAppState>()(
  devtools((_set, _get) => ({
    formatPhone: (phone: string): string => {
      // Remove all non-numeric characters
      const digits = phone.replace(/\D/g, '');

      // If already starts with country code 55 (Brazil) and has enough digits, use as-is
      if (digits.startsWith('55') && digits.length >= 12) {
        return digits;
      }

      // Otherwise prepend Brazil country code
      return `55${digits}`;
    },

    buildMessage: ({
      propertyId,
      propertyCode,
      titulo,
      valor,
      operacao
    }: Omit<IWhatsAppMessageParams, 'phone'>): string => {
      const valorFormatado = valor
        ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : 'a consultar';

      return (
        `Olá! Tenho interesse no seguinte imóvel:\n\n` +
        `- *${titulo}*\n` +
        `- Código: ${propertyCode}${propertyId}\n` +
        `- Valor: ${valorFormatado}\n` +
        `- Operação: ${operacao}\n\n` +
        `Poderia me fornecer mais informações?`
      );
    },

    openWhatsApp: (params: IWhatsAppMessageParams): void => {
      const { phone, ...messageParams } = params;
      const { formatPhone, buildMessage } = _get();

      const formattedPhone = formatPhone(phone);
      const message = buildMessage(messageParams);
      const encodedMessage = encodeURIComponent(message);

      const url = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }))
);
